import { z } from 'zod';
import { catalogueStatusSchema } from '../../common/schemas/enum.schemas.js';
import { uuidSchema } from '../../common/schemas/id.schemas.js';
import { paginatedSchema, paginationInputSchema, sortInputSchema } from '../../common/schemas/pagination.schemas.js';
export const protocolSchema = z.object({
    id: uuidSchema,
    code: z.string().min(1),
    version: z.number().int().min(1),
    name: z.string().min(1),
    metric: z.string().min(1),
    unit: z.string().min(1),
    description: z.string().nullable(),
    status: catalogueStatusSchema,
    effectiveFrom: z.string().nullable(),
    effectiveTo: z.string().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const PROTOCOL_SORT_FIELDS = ['code', 'version', 'name', 'createdAt'];
export const protocolSortBySchema = z.enum(PROTOCOL_SORT_FIELDS);
export const listProtocolsInputSchema = z.object({
    ...paginationInputSchema.shape,
    ...sortInputSchema.shape,
    sortBy: protocolSortBySchema.default('code'),
    search: z.string().trim().min(1).optional(),
    status: catalogueStatusSchema.optional(),
});
export const listProtocolsOutputSchema = paginatedSchema(protocolSchema);
//# sourceMappingURL=protocols.schemas.js.map